import { usePropertyFilters } from '@core/offices/store/filters';
import { LocationFilter } from '@core/offices/types';
import { Operator } from '@graphql/hooks-and-types';

const mappedOperatorsToMeaningfulValues: { [key in Operator]: string } = {
  [Operator.Between]: '-',
  [Operator.Contains]: '-',
  [Operator.Equals]: '=',
  [Operator.GreaterThan]: '>',
  [Operator.GreaterThanOrEqual]: '+',
  [Operator.In]: '-',
  [Operator.LessThan]: '<',
  [Operator.LessThanOrEqual]: '-',
  [Operator.Like]: '-',
  [Operator.StartsWith]: '-',
  [Operator.EndsWith]: '-',
  [Operator.Not]: '-',
};

export const useGetStaticFilters = () => {
  return usePropertyFilters((state) => state.getStaticFilters());
};

export const useGetSelectedLocationType = () => {
  return usePropertyFilters((state) => state.getLocationType());
};

export const useGetDynamicFilterValues = () => {
  return usePropertyFilters((state) => state.getFilter());
};

export const useGetAvailableUnitTypes = () => {
  return usePropertyFilters((state) => state.getAvailableUnitTypes());
};

export const useGetAvailablePropertyTypes = () => {
  return usePropertyFilters((state) => state.getAvailablePropertyTypes());
};

export const useGetAvailableUnitTypeFilters = () => {
  return usePropertyFilters((state) => state.getAvailableUnitTypeFilters());
};

export const useGetAvailableAmenities = () => {
  return usePropertyFilters((state) => state.getAvailableAmenities());
};

export const useGetPriceRangeData = () => {
  return usePropertyFilters((state) => state.getPriceRangeData());
};

export const useIsExactChecked = (filter: LocationFilter): { isExactChecked: boolean | null; valuePrefix: string } => {
  const isExactChecked = usePropertyFilters((state) =>
    state.getFilter()[filter.fieldName] ? state.getFilter()[filter.fieldName].exact : undefined,
  );
  const valuePrefix =
    !isExactChecked && filter.secondaryOperator ? mappedOperatorsToMeaningfulValues[filter.secondaryOperator] : '';
  return { valuePrefix, isExactChecked };
};

export const useGetAddressCoordinates = () => {
  return usePropertyFilters((state) => state.getAddressCoordinates());
};
